import React from 'react';
import './style.scss';
//import LandingFooterRoadmap from './roadmap';
import LandingFooterTeam from './team';
import LandingFooterInfo from './info';
import CirclesBackground from '../../../../general/circlesBackground';
import Copyright from '../../../../general/copyright';
import LandingFooterRanks from './ranks';

const LandingFooterSection = () => (
  <div id='footer-wrapper' className='landing-footer-section'>
    <CirclesBackground
      backgroundColor={'#482893'}
      scale={3.5}
      top='100vh'
      size='min(25vw, 30vh)'
    />
    <div className='lfs-content'>
      <LandingFooterRanks />
      {/* <LandingFooterRoadmap />*/}
      <LandingFooterTeam />
      <LandingFooterInfo />
      <Copyright />
    </div>
  </div>
);

export default LandingFooterSection;
